import React from "react";
import styled from "styled-components";

const StyledVerticlePadding = styled.div`
  padding: 1em 0;
  @media (min-width: 800px) {
    padding: 1.1em 0;
  }
`;

const PaddingVertical = ({ children }: any) => {
  return <StyledVerticlePadding>{children}</StyledVerticlePadding>;
};

export default PaddingVertical;
